/** Why MeetNPlan: feature cards, each topped by a picture of the feature. */
import whyArabic from '@/assets/images/why/arabic-first.webp'
import whyClientInvites from '@/assets/images/why/client-invites.webp'
import whyEmailInvites from '@/assets/images/why/email-invites.webp'
import whyCalendar from '@/assets/images/why/google-calendar.webp'
import whyMessaging from '@/assets/images/why/messaging.webp'
import whyRooms from '@/assets/images/why/rooms.webp'
import whyVideo from '@/assets/images/why/video-meetings.webp'
import whyVisitors from '@/assets/images/why/visitors.webp'

export const WHY = {
  eyebrow: 'Why MeetNPlan',
  title: 'Built for how offices\nhere actually work',
  text: 'Right-to-left Arabic throughout, Saudi date formats, visitor sign-in with signatures, and approvals that go to HR before a room is confirmed. It connects to the calendars your team already uses.',
  // Each card: its `image` (drawn 308×216 at 2x), the `accent` colour of its
  // tag and wash (a key of ACCENTS in WhySection), and the `tag` itself.
  items: [
    {
      image: whyArabic,
      accent: 'blue',
      tag: 'Language',
      title: 'Arabic first',
      text: 'Full right-to-left layout and Arabic text, with English one tap away.',
    },
    {
      image: whyCalendar,
      accent: 'red',
      tag: 'Integrations',
      title: 'Google Calendar',
      text: 'Meetings sync to the calendar your team already uses.',
    },
    {
      image: whyVisitors,
      accent: 'teal',
      tag: 'Reception',
      title: 'Visitors handled',
      text: 'Sign-in, signatures and host alerts, so guests are never left waiting.',
    },
    {
      image: whyMessaging,
      accent: 'violet',
      tag: 'Messaging',
      title: 'Internal messaging',
      text: 'Direct, group and meeting chats with read receipts, replies and file sharing.',
    },
    {
      image: whyEmailInvites,
      accent: 'blue',
      tag: 'Invites',
      title: 'One-click email invites',
      text: 'Send meeting invites by email in one click, with replies tracked for every attendee.',
    },
    {
      image: whyClientInvites,
      accent: 'orange',
      tag: 'Guests',
      title: 'Client invites',
      text: 'Invite people from outside the company. They are marked as external guests.',
    },
    {
      image: whyRooms,
      accent: 'green',
      tag: 'Rooms',
      title: 'Room management',
      text: 'Set up rooms with capacity and equipment, and see which are free right now.',
    },
    {
      image: whyVideo,
      accent: 'teal',
      tag: 'Video',
      title: 'Online & video meetings',
      text: 'Add a video link to any meeting, or meet in a room and online at the same time.',
    },
  ],
}
